<template>
  <v-dialog max-width="1200" v-model="show">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex>
            Logs: {{ function_name }}
          </v-flex>
          <v-flex style="text-align:right">
            <v-btn text @click="loadLog" :loading="l_logs"><i class="fad fa-sync" style="margin-right:5px;"></i>Refresh</v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="logs"
          :headers="[
            {
              text: 'Date / Time',
              value: 'date',
              width: 130
            },
            {
              text: 'HTTP Code',
              value: 'http_status',
              width: 70
            },
            {
              text: 'Content',
              value: 'log_content'
            }
          ]"
          v-if="loaded"
        >
          <template v-slot:item.log_content="{ item }">
            <pre>{{ item.log_content }}</pre>
          </template>
          <template v-slot:item.http_status="{ item }">
            <v-chip :color="getColorFromStatusCode(item.http_status)">{{ item.http_status }}</v-chip>
          </template>
        </v-data-table>
        <LoadingScreen v-else></LoadingScreen>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import LoadingScreen from "../../components/general/Loading";
import { Functions } from "../../logic/Functions";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    function_id: {
      type: Number,
      required: true,
    },
    function_name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logs: [],
      loaded: false,
      l_logs: false
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    show(isOpen) {
      if (isOpen) {
        this.loadLog();
      }
    },
  },
  methods: {
    async loadLog() {
      this.l_logs = true;
      var response = await Functions.loadLogs(this.function_id);
      if (response.status === 200) {
        this.logs = response.body;
      }
      this.loaded = true;
      setTimeout(function () {
        this.l_logs = false;
      }.bind(this), 1000)
    },
    getColorFromStatusCode(http_status) {
        if (http_status >= 200 && http_status <= 299) {
            return "green";
        } else if (http_status >= 400 && http_status <= 599) {
            return "red";
        } else if (http_status >= 300 && http_status <= 399) {
            return "orange";
        } else {
            return "grey";
        }
    }
  },
  components: {
    LoadingScreen
  }
};
</script>

<style>
</style>